import { makeAutoObservable } from 'mobx'
import { AxiosError } from 'axios'

import { logger } from 'shared/lib'
import { AiCallingApi } from 'entities/AICalling/api/aiCallingApi'
import { type IResponseFullAICallingAgent } from 'entities/AICalling/api/types'

type ICallingAgentIdStoreProps = {
  options: {
    response?: IResponseFullAICallingAgent
    onError: (e: AxiosError) => void
    onSetAgent?: (agent: IResponseFullAICallingAgent) => void
  }
}

export class CallingAgentIdStore {
  private _onSetAgent: ICallingAgentIdStoreProps['options']['onSetAgent']
  private _onError: ICallingAgentIdStoreProps['options']['onError']
  constructor(readonly id: number, options: ICallingAgentIdStoreProps['options']) {
    this._onSetAgent = options.onSetAgent
    this._onError = options.onError
    if (options.response) {
      this._loading = false
      this._setAgent(options.response)
    } else {
      this._load()
    }

    makeAutoObservable(this)
  }

  private _agent: IResponseFullAICallingAgent | null = null
  get agent() {
    return this._agent
  }
  syncOrigin = (agent: IResponseFullAICallingAgent) => {
    this._agent = agent
  }
  private _setAgent = (agent: IResponseFullAICallingAgent) => {
    this._onSetAgent?.(agent)
    this.syncOrigin(agent)
  }

  private _load = async () => {
    try {
      const { data } = await AiCallingApi.getById(this.id)
      this._setAgent(data)
    } catch (e) {
      if (e instanceof AxiosError) {
        this._onError(e)
      }

      logger.error(e)
    } finally {
      this.setLoading(false)
    }
  }

  private _loading = true
  get loading() {
    return this._loading
  }
  setLoading = (value: boolean) => {
    this._loading = value
  }
}
